import type { Receipt } from '../types';

/** EUR value for reporting: explicit `amount_eur`, else `amount` when currency is EUR. */
export function receiptAmountEurForSummary(r: Receipt): number {
  const eurStr = r.amount_eur != null ? String(r.amount_eur).trim() : '';
  if (eurStr !== '') {
    const n = parseFloat(eurStr);
    return Number.isNaN(n) ? 0 : n;
  }
  if ((r.currency || 'EUR').toUpperCase() === 'EUR') {
    const n = parseFloat(r.amount) || 0;
    return Number.isNaN(n) ? 0 : n;
  }
  return 0;
}
